import type { BackendRouteDefinition } from '../types';

// Flipped from `transport: 'callable'` to `transport: 'api'` by S3-WB1
// (PRA-789). Now served by `api-core-node` at
// `POST /api/firms/arag/sessions/sign-out`. See `signIntoArag.ts` for the
// retirement-deferred callable note.

export const signOutOfAragRoute = {
  transport: 'api',
  method: 'POST',
  path: '/firms/arag/sessions/sign-out',
} as const satisfies BackendRouteDefinition;
